import { ComponentPropsWithoutRef } from 'react';
import styled from 'styled-components';

export const StatusActiveIcon = (props: ComponentPropsWithoutRef<'svg'>) => {
  return (
    <StyledIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 89 89"
      shapeRendering="geometricPrecision"
      textRendering="geometricPrecision"
      width="89"
      height="89"
      {...props}
    >
      <defs>
        <filter id="eRP6idyQqhJ3-filter" x="-150%" width="400%" y="-150%" height="400%">
          <feGaussianBlur id="eRP6idyQqhJ3-filter-blur-0" stdDeviation="11.4344,11.4344" result="result" />
        </filter>
        <filter id="eRP6idyQqhJ9-filter" x="-150%" width="400%" y="-150%" height="400%">
          <feGaussianBlur id="eRP6idyQqhJ9-filter-blur-0" stdDeviation="2.3452,2.3452" result="result" />
        </filter>
      </defs>
      <g transform="translate(-.057449-.057449)">
        <g style={{ mixBlendMode: 'screen' }} opacity="0.8" filter="url(#eRP6idyQqhJ3-filter)">
          <g id="eRP6idyQqhJ4_ts" transform="translate(44.557449,44.557449) scale(0.670848,0.670848)">
            <path
              d="M23,44.5574L44.5574,23L66.1149,44.5574L44.5574,66.1149L23,44.5574Z"
              transform="translate(-44.557449,-44.557449)"
              fill="#1b39ff"
            />
          </g>
        </g>
        <g id="eRP6idyQqhJ5_ts" transform="translate(44.55745,44.55745) scale(0.397744,0.397744)">
          <circle id="eRP6idyQqhJ5" r="17.59926" transform="translate(0,-0.000001)" opacity="0.1" fill="#3ea2ff" />
        </g>
        <g id="eRP6idyQqhJ6_ts" transform="translate(44.55745,44.55745) scale(0.496982,0.496982)">
          <circle id="eRP6idyQqhJ6" r="14.085017" transform="translate(0,0)" opacity="0.2" fill="#3ea2ff" />
        </g>
        <g id="eRP6idyQqhJ7_ts" transform="translate(44.55746,44.557439) scale(0.6622,0.662198)">
          <circle id="eRP6idyQqhJ7" r="10.57084" transform="translate(0,0)" opacity="0.2" fill="#3ea2ff" />
        </g>
        <circle r="7" transform="translate(44.55745 44.55745)" fill="#5effd7" />
        <g filter="url(#eRP6idyQqhJ9-filter)">
          <circle r="3.21574" transform="translate(44.5574 44.498)" fill="#edfaf5" />
        </g>
      </g>
    </StyledIcon>
  );
};

const StyledIcon = styled.svg`
  #eRP6idyQqhJ4_ts {
    animation: eRP6idyQqhJ4_ts__ts 3000ms linear infinite normal forwards;
  }
  @keyframes eRP6idyQqhJ4_ts__ts {
    0% {
      transform: translate(44.557449px, 44.557449px) scale(0.670848, 0.670848);
      animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
    }
    66.666667% {
      transform: translate(44.557449px, 44.557449px) scale(1, 1);
    }
    93.333333% {
      transform: translate(44.557449px, 44.557449px) scale(0.670849, 0.670849);
    }
    100% {
      transform: translate(44.557449px, 44.557449px) scale(0.670849, 0.670849);
    }
  }
  #eRP6idyQqhJ5_ts {
    animation: eRP6idyQqhJ5_ts__ts 3000ms linear infinite normal forwards;
  }
  @keyframes eRP6idyQqhJ5_ts__ts {
    0% {
      transform: translate(44.55745px, 44.55745px) scale(0.397744, 0.397744);
    }
    13.333333% {
      transform: translate(44.55745px, 44.55745px) scale(0.397744, 0.397744);
    }
    76.666667% {
      transform: translate(44.55745px, 44.55745px) scale(1.573992, 1.573987);
    }
    100% {
      transform: translate(44.55745px, 44.55745px) scale(1.573992, 1.573987);
    }
  }
  #eRP6idyQqhJ5 {
    animation: eRP6idyQqhJ5_c_o 3000ms linear infinite normal forwards;
  }
  @keyframes eRP6idyQqhJ5_c_o {
    0% {
      opacity: 0.1;
    }
    16.666667% {
      opacity: 0.1;
    }
    43.333333% {
      opacity: 0.1;
    }
    73.333333% {
      opacity: 0;
    }
    100% {
      opacity: 0;
    }
  }
  #eRP6idyQqhJ6_ts {
    animation: eRP6idyQqhJ6_ts__ts 3000ms linear infinite normal forwards;
  }
  @keyframes eRP6idyQqhJ6_ts__ts {
    0% {
      transform: translate(44.55745px, 44.55745px) scale(0.496982, 0.496982);
    }
    26.666667% {
      transform: translate(44.55745px, 44.55745px) scale(0.496982, 0.496982);
    }
    86.666667% {
      transform: translate(44.55745px, 44.55745px) scale(1.530523, 1.530523);
    }
    100% {
      transform: translate(44.55745px, 44.55745px) scale(1.530523, 1.530523);
    }
  }
  #eRP6idyQqhJ6 {
    animation: eRP6idyQqhJ6_c_o 3000ms linear infinite normal forwards;
  }
  @keyframes eRP6idyQqhJ6_c_o {
    0% {
      opacity: 0.2;
    }
    30% {
      opacity: 0.2;
    }
    56.666667% {
      opacity: 0.2;
    }
    83.333333% {
      opacity: 0;
    }
    100% {
      opacity: 0;
    }
  }
  #eRP6idyQqhJ7_ts {
    animation: eRP6idyQqhJ7_ts__ts 3000ms linear infinite normal forwards;
  }
  @keyframes eRP6idyQqhJ7_ts__ts {
    0% {
      transform: translate(44.55746px, 44.557439px) scale(0.6622, 0.662198);
    }
    40% {
      transform: translate(44.55746px, 44.557439px) scale(0.6622, 0.662198);
    }
    90% {
      transform: translate(44.55746px, 44.557439px) scale(1.368083, 1.368084);
    }
    100% {
      transform: translate(44.55746px, 44.557439px) scale(1.368083, 1.368084);
    }
  }
  #eRP6idyQqhJ7 {
    animation: eRP6idyQqhJ7_c_o 3000ms linear infinite normal forwards;
  }
  @keyframes eRP6idyQqhJ7_c_o {
    0% {
      opacity: 0.2;
    }
    43.333333% {
      opacity: 0.2;
    }
    70% {
      opacity: 0.2;
    }
    86.666667% {
      opacity: 0;
    }
    100% {
      opacity: 0;
    }
  }
`;
